import { WidgetsServicesReturnFormMain } from '@/widgets/services-return-form';

export const PagesServicesReturnFormMain = () => <WidgetsServicesReturnFormMain />;
